// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_2ef4e24b","outerContainer":"_8a9ae041","secondaryToolbar":"_390b84d0","doorHangerRight":"_3b601446","toolbarContainer":"_522a4cfd","toolbarViewerMiddle":"_3553bde9","progressBar":"_3caea5c4","back-to-application":"_6cf8df5e","root":"_2ea1f1bd","name":"_22945290","icon":"_3373598f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/CollapsedBar/styles.styl
// module id = 5154
// module chunks = 39